import { IPaginatedResponse, IPagination } from '@sdk/contracts';
import { createQueryString } from '@utils';

import { RequestService } from '../request';

import { ICreatePost, IPost, IPostFilters } from './post.contract';


export class PostService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  async getPosts(pagination: IPagination, filters: IPostFilters) {
    const { page, limit } = pagination;
    const queryParams: Record<string, any> = { page, limit, filters };
    const query = createQueryString(queryParams);
    return this.fetcher<IPaginatedResponse<IPost>>(`/blog/posts?${query}`);
  }

  async createPost(data: ICreatePost) {
    return this.poster<IPost, ICreatePost>('/blog/posts', data);
  }

  async updatePost(data: Partial<IPost>) {
    return this.putter<IPost, Partial<IPost>>(`/blog/posts/${data._id}`, data);
  }

  async getPost(postId: string) {
    return this.fetcher<IPost>(`/blog/posts/${postId}`);
  }

  async getRelatedPosts(postId: string) {
    return this.fetcher<IPost[]>(`/blog/posts/${postId}/related`);
  }

  async remove(postId: string) {
    return this.deleter(`/blog/posts/${postId}`);
  }
}
